import React from 'react';

const AdminRevenue = () => {
    return (
        <>
            
        </>
    );
};

export default AdminRevenue;
